import API from "./axiosClient";

export const googleLogin = async (data) => {
  return API.post("/user/google_login", data);
};

export const facebookLogin = async (data) => {
  return API.post("/user/fb_login", data);
};
